export default __webpack_public_path__ + "static/media/excellent_inactive.c4befdfc.svg";